import { render, staticRenderFns } from "./Appointment_Add_ModalX.vue?vue&type=template&id=6d6645d7&scoped=true&"
import script from "./Appointment_Add_ModalX.vue?vue&type=script&lang=js&"
export * from "./Appointment_Add_ModalX.vue?vue&type=script&lang=js&"
import style0 from "./Appointment_Add_ModalX.vue?vue&type=style&index=0&id=6d6645d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6645d7",
  null
  
)

export default component.exports